import Account from 'static/models/Account';

export function getPackageText(account: Account): string {
    if (account.state === 'NY') {
        return 'Offering';
    } else {
        return 'Package';
    }
}
